module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M7 10v8h6v-8h5l-8-8-8 8h5z\"/></svg>"